export default __webpack_public_path__ + "static/media/Alchemy-Analytics-Desktop.8ebc309b.jpg";